export default "__VITE_ASSET__DT47l58V__"